import { AfterViewInit, ChangeDetectorRef, Component, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Dialog } from 'primeng';
import { ConfirmationService } from 'primeng/api';
import { AllLabels } from './constants/app.constants';
import { UserInfo } from './domains/common.domain';
import { NavigationMenu } from './interface/config.interface';
import { LocalStorageService } from './services/local-storage.service';
import { NetzTranslateService } from './services/netz-translate.service';
import { UserService } from './services/user.service';
import { CommunicationService } from './services/communication.service';
import { Title } from '@angular/platform-browser';
import { EnvironmentService } from './services/environment.service';
import { version } from '../../package.json';

import { environment } from '../environments/environment';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ConfirmationService],
})
export class AppComponent implements AfterViewInit, OnInit {
  @ViewChild('dialogElement') dialog: Dialog;

  appLabels: {
    [key: string]: string;
  };
  currentUrl: string;
  displayPosition: boolean;
  showLoginIcon: boolean;
  title: string = 'netz-portal';
  userEmailId: string;
  role: string;
  showLanguageSelector: boolean;
  version = version;

  constructor(
    private netzTranslateService: NetzTranslateService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private userService: UserService,
    private renderer: Renderer2,
    private communicationService: CommunicationService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
    private titleService: Title,
    private environmentService: EnvironmentService
  ) {
    this.appLabels = AllLabels.app;
    this.displayPosition = false;
    this.userEmailId = '';
    this.currentUrl = '';

    // todo: this is an ugly fix for technician_id being string in inubit, integer/number in .NET. improve!
    this.showLoginIcon = !(
      this.localStorageService.getItem('technician_id') &&
      (this.localStorageService.getItem('technician_id').length > 0 || this.localStorageService.getItem('technician_id') > 0)
    );
    this.userEmailId = this.localStorageService.getItem('user_email') || '';
    this.role = this.localStorageService.getItem('role');
    this.userService.updateUserData.subscribe((data: UserInfo) => {
      this.showLoginIcon = false;
      this.displayPosition = false;
      this.userEmailId = (data && data.user_email) || this.localStorageService.getItem('user_email');
      this.cdr.detectChanges();
      this.role = this.localStorageService.getItem('role');
    });
    this.currentUrl = document.location.href;
    this.handleClickEvent();
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.environmentService.pageTitle);
    this.showLanguageSelector = this.environmentService.showLanguageSelector;

    if (this.userService.userLoginData === null && this.currentUrl.indexOf('successful-registration') === -1) {
      // TODO: what?!
      // this.router.navigate(['']);
    }
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  isMenuOpen(): boolean {
    return this.userService.isMenuOpen;
  }

  showLoginForm(): void {
    this.showLanguageSelector = this.environmentService.showLanguageSelector;
    this.displayPosition = true;
  }

  logout(): void {
    this.confirmationService.confirm({
      accept: () => {
        setTimeout(() => {
          this.userService.clearUserData();

          const lookUpData = this.localStorageService.getItem('lookup_data');
          this.localStorageService.clear();
          if (lookUpData) {
            this.localStorageService.setItem('lookup_data', lookUpData);
          }
          this.router.navigate(['/dashboard']);
          this.showLoginIcon = true;
        }, 1000);
      },
      reject: () => {
        this.confirmationService.close();
      },
    });
  }

  handleNavigationEvent(event: NavigationMenu): void {
    if (event && event.label === 'logout') {
      this.logout();
    }
  }

  getLocalisationLanguages(): Array<string> {
    return this.netzTranslateService.getLangs();
  }

  getCurrentLanguage(): string {
    return this.netzTranslateService.getCurrentLang();
  }

  useLocalisationLanguage(selectedLanguage: string): void {
    this.netzTranslateService.useLanguage(selectedLanguage);
  }

  onActivate() {
    window.scroll(0, 0);
  }

  showHomeIcon(): boolean {
    const urlSegments = document.location.href.split('/');
    if (urlSegments && urlSegments.length) {
      return urlSegments[urlSegments.length - 1] === 'impressum';
    }
    return false;
  }

  visitHome(): void {
    this.router.navigate(['/dashboard']);
  }

  private handleClickEvent(): void {
    this.communicationService.registerForActionOnDashboardClick.subscribe(value => {
      if (value && this.showLoginIcon) {
        this.showLoginForm();
      } else {
        this.showLoginIcon = true;
        this.displayPosition = false;
      }
    });
  }
}
